import {createContext} from 'react';

export const PaymentReferenceContext = createContext({});
export const UserContext = createContext(null);
